<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Succursales</h1>
                    <p>Gestion des succursales</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.branch.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une succursale</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" activeAdvancedFilter="false" :paginator="paginator" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>

                            <div></div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Adresse', value:'street'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Code Postal', value:'postal_code'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Localité', value:'locality'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="center">
                                <span data-sort="is_headquarter">Siège social</span>
                            </div>
                            <div class="center">
                                <span data-sort="is_storage">Entrepôt</span>
                            </div>
                            <div class="center">
                                <span data-sort="is_store">Boutique</span>
                            </div>
                            <div class="actions"></div>
                            <div></div>

                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.branch.view', item.id )">
                            <div></div>
                            <div data-field="name"><strong class="highlight">{{ item.name }}</strong></div>
                            <div data-field="street">{{ item.street }} {{ item.street_number }}</div>
                            <div data-field="postal_code">{{ item.postal_code }}</div>
                            <div data-field="locality">{{ item.locality }}</div>
                            <div class="center"><checked v-model="item.is_headquarter"></checked></div>
                            <div class="center"><checked v-model="item.is_storage"></checked></div>
                            <div class="center"><checked v-model="item.is_store"></checked></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.branch.showmap')"><a target="_blank" :href="'http://maps.google.com/maps?q='+item.lat+','+item.lng"><i class="icon icon-icon_earth"></i></a></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.branch.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.branch.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import BranchService from './BranchService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return BranchService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/branch/Index.vue